var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "done_all_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/done_all_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.205 5.29501L11.625 15.875L7.445 11.705L6.035 13.115L11.625 18.705L23.625 6.70501L22.205 5.29501ZM17.965 6.70501L16.555 5.29501L10.215 11.635L11.625 13.045L17.965 6.70501ZM5.965 18.705L0.375 13.115L1.795 11.705L7.375 17.295L5.965 18.705Z",
    fill: "#fad504"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll);
export default __webpack_public_path__ + "static/media/done-all.aa86ecfbecf782ec7f7f02705b544163.svg";
export { ForwardRef as ReactComponent };